import axiosInstance from '../config/axios';

const getAuthHeader = (extraHeaders = {}) => {
  const token = localStorage.getItem('authToken');
  return {
    ...extraHeaders,
    ...(token ? { Authorization: `Bearer ${token}` } : {})
  };
};

/**
 * Fetch list of videos
 * @param {object} params Optional pagination or filtering parameters
 */
export const getVideosApi = (params = {}) =>
  axiosInstance.get('/list-videos', { params, headers: getAuthHeader() }).then((res) => res.data);

export const likeVideoApi = (videoId, userId) =>
  axiosInstance.post(`/like`, { video_id: videoId, user_id: userId }, { headers: getAuthHeader() }).then((res) => res.data);

export const saveVideoApi = (videoId) =>
  axiosInstance.post(`/save-post`, { post_id: videoId }, { headers: getAuthHeader() }).then((res) => res.data);

export const shareVideoApi = (videoId, userId, platform = 'web') =>
  axiosInstance.post(`/share`, { video_id: videoId, user_id: userId, platform }, { headers: getAuthHeader() }).then((res) => res.data);

export const getCommentsApi = (videoId) =>
  axiosInstance.get(`/posts/${videoId}/comments`, { headers: getAuthHeader() }).then((res) => res.data);

export const addCommentApi = (videoId, userId, comment) =>
  axiosInstance.post(`/comment`, { video_id: videoId, user_id: userId, comment }, { headers: getAuthHeader() }).then((res) => res.data);

export const uploadVideoApi = (formData, onUploadProgress) =>
  axiosInstance.post('/posts', formData, {
    headers: {
      ...getAuthHeader(),
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress,
  }).then((res) => res.data);

/**
 * Search teacher videos
 * @param {object} params
 */
export const searchVideosApi = (params = {}) =>
  axiosInstance.get('/search-videos', { params, headers: getAuthHeader() }).then((res) => res.data);

/**
 * Get video details by ID
 * @param {string} id
 */
export const getVideoByIdApi = (id) =>
  axiosInstance.get(`/video/${id}`, { headers: getAuthHeader() }).then((res) => res.data);

/**
 * Add view count to a video
 * @param {string} videoId
 */
export const addVideoViewApi = (videoId) =>
  axiosInstance.post('/add-video-view', { video_id: videoId }, { headers: getAuthHeader() }).then((res) => res.data);

/**
 * Get video views count
 * @param {string} videoId
 */
export const getVideoViewsCountApi = (videoId) =>
  axiosInstance.get(`/video/${videoId}/views`, { headers: getAuthHeader() }).then((res) => res.data);

/**
 * Sync video view count
 * @param {string} videoId
 * @param {object} data
 */
export const syncVideoViewCountApi = (videoId, data = {}) =>
  axiosInstance.post(`/video/${videoId}/sync-views`, data, { headers: getAuthHeader() }).then((res) => res.data);

/**
 * Generate shareable deep link URL for video
 * @param {{ videoId: string }} data
 */
export const getVideoDeepLinkUrlApi = (data) =>
  axiosInstance.post('/video/deep-link', data).then((res) => res.data);

/**
 * Delete video by ID
 * @param {string} id
 */
export const deleteVideoApi = (id) =>
  axiosInstance.delete(`/delete-video/${id}`, { headers: getAuthHeader() }).then((res) => res.data);


